// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3LUwy","buttons":"RemoveExpirationActionButtons_buttons__2t9U1"};